import PreviewSection from "./PreviewSection";
import { STEP } from "./designerSteps";

const DesignerPreviewPanel = ({
    selectedParts,
    root,
    view,
    selectedPrints,
    printDetails,
    allColors,
    activePrintKey,
    onSelectPrint,
    onTransformPrint,
    onDeletePrint,
    onEditPrintColor,
    onPrintClipWarning,
    partHotspots,
    onSelectPart,
    canFlip,
    onToggleView,
    onResetDesign,
    currentStep,
    currentStepKey,
    stripeColors,
    totalSteps,
    saving,
    saveDisabled,
    onPrev,
    onNext,
    onSave,
    stripeDrawingsBySide,
    stripeDrawEditor,
    onSetStripeDrawEditor,
    onUpdateStripeDrawingsBySide,
    customCutsBySide,
    customCutEditor,
    onSetCustomCutEditor,
    onUpdateCustomCutsBySide,
    customCutZoneColors,
    onCustomCutRuntimeUpdate,
    onPreviewPaintCustomCutZone,
    highlightedPartKey,
    sparklePartKeys,
    sparkleToken,
    highlightedCustomCutZoneId,
    sparkleCustomCutZoneIds,
    sparkleCustomCutToken,
}) => {
    return (
        <PreviewSection
            selectedParts={selectedParts}
            root={root}
            view={view}
            selectedPrints={selectedPrints}
            printDetails={printDetails}
            allColors={allColors}
            showPrints={true}
            activePrintKey={activePrintKey}
            onSelectPrint={onSelectPrint}
            onTransformPrint={onTransformPrint}
            onDeletePrint={onDeletePrint}
            onEditPrintColor={onEditPrintColor}
            onPrintClipWarning={onPrintClipWarning}
            partHotspots={partHotspots}
            onSelectPart={onSelectPart}
            showHotspots={false}
            canFlip={canFlip}
            onToggleView={onToggleView}
            onResetDesign={onResetDesign}
            currentStep={currentStep}
            totalSteps={totalSteps}
            saving={saving}
            nextDisabled={false}
            saveDisabled={saveDisabled}
            onPrev={onPrev}
            onNext={onNext}
            onSave={onSave}
            enablePrintEditing={currentStepKey === STEP.PRINTS}
            enablePartPaint={currentStepKey === STEP.PAINT}
            enableStripeEditing={currentStepKey === STEP.STRIPES}
            stripeColors={stripeColors}
            stripeDrawingsBySide={stripeDrawingsBySide}
            stripeDrawEditor={stripeDrawEditor}
            onSetStripeDrawEditor={onSetStripeDrawEditor}
            onUpdateStripeDrawingsBySide={onUpdateStripeDrawingsBySide}
            customCutsBySide={customCutsBySide}
            customCutEditor={customCutEditor}
            onSetCustomCutEditor={onSetCustomCutEditor}
            onUpdateCustomCutsBySide={onUpdateCustomCutsBySide}
            customCutZoneColors={customCutZoneColors}
            onCustomCutRuntimeUpdate={onCustomCutRuntimeUpdate}
            onPreviewPaintCustomCutZone={onPreviewPaintCustomCutZone}
            highlightedPartKey={highlightedPartKey}
            sparklePartKeys={sparklePartKeys}
            sparkleToken={sparkleToken}
            highlightedCustomCutZoneId={highlightedCustomCutZoneId}
            sparkleCustomCutZoneIds={sparkleCustomCutZoneIds}
            sparkleCustomCutToken={sparkleCustomCutToken}
        />
    );
};

export default DesignerPreviewPanel;
